import styled from 'styled-components';

const blue = '#003876';

const MenuContainer = styled.div`
  height: 20px;
  width: 37px;
  display: flex;
  justify-content: space-evenly;
  align-self: flex-end;
  margin-left: auto;
  margin-right: 28px;
  user-select: none;
  position: absolute;
  right: 0;
  top: 35px;

  &:hover {
    cursor: pointer;
  }
`;

const Dot = styled.span`
  border-radius: 50%;
  background: #fff;
  height: 5px;
  user-select: none;
  width: 5px;
  align-self: center;
`;

const DropDownMenu = styled.nav`
  display: block;
  z-index: 100;
  height: 110px;
  width: 115px;
  top: 60px;
  left: 46px;
  background-color: #fafbfd;
  position: absolute;
  padding: 10px;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-direction: column;
`;
const Mdiv = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 35px;
  padding-left: 10%;

  @media (max-width: 779px) {
    padding-left: 0px;
  }
`;

const Mh2 = styled.h2`
  color: ${blue};
  font-family: 'Montserrat';
`;

const Mul = styled.ul`
  list-style-type: none;
  padding: 0;
`;

const Mli = styled.li`
  color: ${blue};
  padding: 5px;
  font-weight: 500;
  font-family: 'Montserrat';
`;

const MButtonContainer = styled.div`
  margin-top: auto;
  z-index: 3;
  width: 100%;
  height: 100%;
  margin-bottom: 30px;
`;

const MImage = styled.img`
  max-width: 55%;
  margin-top: 20px;

  @media (max-width: 715px) {
    padding-left: 10px;
    margin-top: 51px;
  }

  @media (min-width: 779px) {
    max-width: 100%;
    width: 450px;
    margin-top: 51px;
  }

  @media (min-width: 960px) {
    width: 52%;
    margin-top: 51px;
    max-width: 100%;
  }
`;

export {
  MenuContainer,
  Dot,
  DropDownMenu,
  Mdiv,
  Mh2,
  Mul,
  Mli,
  MButtonContainer,
  MImage,
};
